(function () {
  var root = document.querySelector('[data-qr-capture]');
  if (!root) return;

  var STORAGE_KEY = 'qr_popup_dismissed';
  var DISCOUNT_KEY = 'qr_discount_applied';
  var discountCode = root.dataset.discountCode || '';

  function readStore(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function writeStore(key) {
    try {
      sessionStorage.setItem(key, '1');
    } catch (e) {
      // storage unavailable — non-fatal
    }
  }

  // Shopify's /discount/<code> endpoint sets the discount cookie for this
  // browser, so the code is already on the cart at checkout without the
  // customer typing it or leaving the page. Flagged in session storage so a
  // multi-page visit only fires it once.
  function applyDiscount() {
    if (!discountCode || readStore(DISCOUNT_KEY)) return;
    writeStore(DISCOUNT_KEY);
    fetch('/discount/' + encodeURIComponent(discountCode), { credentials: 'same-origin' }).catch(
      function () {}
    );
  }

  // Runs before the dismissal check below, so it still applies for visitors
  // who closed or skipped the popup earlier in the session.
  if (root.dataset.autoApply === 'true') applyDiscount();

  if (readStore(STORAGE_KEY)) {
    root.hidden = true;
    return;
  }

  var apiBaseUrl = (root.dataset.apiBaseUrl || '').replace(/\/$/, '');
  var source = root.dataset.source || 'qr_landing';

  var backdrop = root.querySelector('[data-qr-backdrop]');
  var form = root.querySelector('[data-qr-form]');
  var input = root.querySelector('[data-qr-phone-input]');
  var errorEl = root.querySelector('[data-qr-error]');
  var submitBtn = root.querySelector('[data-qr-submit]');
  var submitLabelEl = root.querySelector('[data-qr-submit-label]');
  var closeBtn = root.querySelector('[data-qr-close]');
  var skipBtn = root.querySelector('[data-qr-skip]');
  var continueBtn = root.querySelector('[data-qr-continue]');
  var formView = root.querySelector('[data-qr-form-view]');
  var doneView = root.querySelector('[data-qr-done-view]');
  var copyBtn = root.querySelector('[data-qr-copy]');
  var submitLabel = submitLabelEl ? submitLabelEl.textContent : '';

  function track(event, props) {
    try {
      if (typeof mixpanel !== 'undefined' && mixpanel.track) {
        props = props || {};
        props.source = source;
        mixpanel.track(event, props);
      }
    } catch (e) {
      // analytics must never break the capture flow
    }
  }

  function lockScroll(locked) {
    document.documentElement.style.overflow = locked ? 'hidden' : '';
  }

  function remember() {
    writeStore(STORAGE_KEY);
  }

  function close(method) {
    // A close from the done view is a completed capture, not a dismissal.
    if (root.dataset.state === 'done') {
      track('QR Popup Continued', { method: method });
    } else {
      track('QR Popup Dismissed', { method: method });
    }
    root.hidden = true;
    lockScroll(false);
    remember();
  }

  function showError(message) {
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function clearError() {
    errorEl.hidden = true;
    errorEl.textContent = '';
  }

  lockScroll(true);
  track('QR Popup Shown');

  if (closeBtn) closeBtn.addEventListener('click', function () { close('close_button'); });
  if (skipBtn) skipBtn.addEventListener('click', function () { close('skip_link'); });
  if (backdrop) backdrop.addEventListener('click', function () { close('backdrop'); });
  if (continueBtn) continueBtn.addEventListener('click', function () { close('continue_button'); });

  if (input) {
    input.addEventListener('input', function () {
      input.value = input.value.replace(/\D/g, '').slice(0, 10);
    });
  }

  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var original = copyBtn.textContent;
      var done = function () {
        copyBtn.dataset.copied = 'true';
        copyBtn.textContent = 'Copied!';
        setTimeout(function () {
          copyBtn.textContent = original;
          copyBtn.dataset.copied = 'false';
        }, 1500);
      };
      track('QR Code Copied', { code: discountCode });
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(discountCode).then(done).catch(function () {});
      } else {
        done();
      }
    });
  }

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearError();

      var phone = (input.value || '').trim();
      if (!/^[6-9]\d{9}$/.test(phone)) {
        showError('Enter a valid 10-digit mobile number.');
        input.focus();
        return;
      }

      if (!apiBaseUrl) {
        showError('Something went wrong. Please try again later.');
        return;
      }

      submitBtn.disabled = true;
      if (submitLabelEl) submitLabelEl.textContent = 'Please wait…';

      fetch(apiBaseUrl + '/api/qr-signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: phone, source: source }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('request_failed');
          return res.json();
        })
        .then(function () {
          root.dataset.state = 'done';
          formView.hidden = true;
          doneView.hidden = false;
          applyDiscount();
          remember();
          track('QR Phone Submitted', { code: discountCode });
        })
        .catch(function () {
          submitBtn.disabled = false;
          if (submitLabelEl) submitLabelEl.textContent = submitLabel;
          showError('Could not submit right now. Please try again.');
        });
    });
  }
})();
